import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UserIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 13.9319 4.68477 15.7038 5.82484 17.0863C6.66767 16.1152 7.91138 15.5 9.3 15.5H14.7C16.0886 15.5 17.3323 16.1152 18.1752 17.0863C19.3152 15.7038 20 13.9319 20 12C20 7.58172 16.4182 4 12 4ZM18.7025 19.4214C20.7275 17.5914 22 14.9443 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 14.9445 3.27265 17.5918 5.29791 19.4218C5.30967 19.4329 5.32173 19.4438 5.33409 19.4543C7.10318 21.0374 9.43918 22 12 22C14.5606 22 16.8964 21.0376 18.6655 19.4547C18.6781 19.4439 18.6905 19.4328 18.7025 19.4214ZM16.7186 18.4609C16.2413 17.8739 15.5137 17.5 14.7 17.5H9.3C8.48635 17.5 7.75871 17.8739 7.28139 18.4609C8.60423 19.4287 10.2354 20 12 20C13.7646 20 15.3958 19.4287 16.7186 18.4609ZM12 7.15C10.5641 7.15 9.4 8.31406 9.4 9.75C9.4 11.1859 10.5641 12.35 12 12.35C13.4359 12.35 14.6 11.1859 14.6 9.75C14.6 8.31406 13.4359 7.15 12 7.15ZM7.4 9.75C7.4 7.20949 9.45949 5.15 12 5.15C14.5405 5.15 16.6 7.20948 16.6 9.75C16.6 12.2905 14.5405 14.35 12 14.35C9.45948 14.35 7.4 12.2905 7.4 9.75Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

UserIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UserIcon);
